import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      'members',
      'special-members',
      'membership-stats',
      'waitlist',
      'archived',
      'payment-history',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      gettMembers: builder.query({
        query: () => ({
          url: 'fishery/members',
          getFullResult: true,
        }),

        providesTags: ['members'],
      }),
      getSpecailMembers: builder.query({
        query: () => ({
          url: 'fishery/special_members',
          getFullResult: true,
        }),
        providesTags: ['special-members'],
      }),
      getWaitlistMembers: builder.query({
        query: () => ({
          url: 'fishery/member/waitlist',
        }),
        providesTags: ['waitlist'],
      }),
      getArchivedMembers: builder.query({
        query: () => ({
          url: 'fishery/member/archived',
        }),
        providesTags: ['archived'],
      }),
      ApproveMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/members/approve',

          method: 'post',
          data: data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'members' },
          { type: 'payment-history' },
          { type: 'waitlist' },
        ],
      }),
      ApproveSpecialMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/special_members/approve',
          method: 'post',
          data: data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'special-members' },
          { type: 'payment-history' },
          { type: 'waitlist' },
        ],
      }),
      deleteMember: builder.mutation({
        query: (id) => ({
          url: 'fishery/members/delete',
          method: 'post',
          data: { id: id },
        }),
        invalidatesTags: (result, error) => [
          { type: 'members' },
          { type: 'archived' },
          { type: 'waitlist' },
        ],
      }),
      salesStats: builder.mutation({
        query: (id) => ({
          url: 'fishery/membership_stats',
          method: 'post',
          data: id,
          useDefaultErrorHandler: false,
        }),
        invalidatesTags: (result, error) => [{ type: 'membership-stats' }],
      }),
      deleteSpecialMember: builder.mutation({
        query: (id) => ({
          url: 'fishery/special_members/delete',
          method: 'post',
          data: { id: id },
        }),
        invalidatesTags: (result, error) => [
          { type: 'special-members' },
          { type: 'archived' },
          { type: 'waitlist' },
        ],
      }),
      UpdateSpecialMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/special_members/details',
          method: 'put',
          data: data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'special-members' },
          { type: 'archived' },
          { type: 'payment-history' },
          { type: 'waitlist' },
        ],
      }),
      UpdateMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/member/details',
          method: 'put',
          data: data,
        }),
        invalidatesTags: (result, error) => [
          { type: 'members' },
          { type: 'payment-history' },
          { type: 'archived' },
          { type: 'waitlist' },
        ],
      }),
      addSpecialMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/special_members/details',
          method: 'post',
          data: data,
        }),
        invalidatesTags: (result, error) => [{ type: 'special-members' }],
      }),
      addMember: builder.mutation({
        query: (data) => ({
          url: 'fishery/member/details',
          method: 'post',
          data: data,
        }),
        invalidatesTags: (result, error) => [{ type: 'members' }],
      }),
      resendPaymentLinkMembers: builder.mutation({
        query: ({ id }) => ({
          url: 'fishery/member/resend_payment_link',
          method: 'post',
          data: { membership_id: id },
        }),
      }),
      resendPaymentLinkSpecialMembers: builder.mutation({
        query: ({ id }) => ({
          url: 'fishery/special_member/resend_payment_link',
          method: 'post',
          data: { membership_id: id },
        }),
      }),
      getPaymentHistoryMembers: builder.query({
        query: ({ id }) => ({
          url: 'fishery/member/payment_history',
          params: { membership_id: id },
          useDefaultErrorHandler: false,
        }),
        providesTags: ['payment-history'],
      }),
      getPaymentHistorySpecialMembers: builder.query({
        query: ({ id }) => ({
          url: 'fishery/special_member/payment_history',
          params: { membership_id: id },
          useDefaultErrorHandler: false,
        }),
        providesTags: ['payment-history'],
      }),

      postReservationBooking: builder.mutation({
        query: (data) => ({
          method: 'post',
          url: `booking/new`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: '' }],
      }),
    }),
  });

export const {
  useGetSpecailMembersQuery,
  useGettMembersQuery,
  useApproveMemberMutation,
  useApproveSpecialMemberMutation,
  useGetWaitlistMembersQuery,
  useGetArchivedMembersQuery,
  useUpdateMemberMutation,
  useUpdateSpecialMemberMutation,
  useAddMemberMutation,
  useAddSpecialMemberMutation,
  useDeleteMemberMutation,
  useDeleteSpecialMemberMutation,
  useSalesStatsMutation,
  useGetPaymentHistoryMembersQuery,
  useGetPaymentHistorySpecialMembersQuery,
  useResendPaymentLinkMembersMutation,
  useResendPaymentLinkSpecialMembersMutation,

  usePostReservationBookingMutation,
} = extendedApiSlice;
